
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ResetConfirmDialogProps {
  showResetDialog: boolean;
  setShowResetDialog: (show: boolean) => void;
  handleResetData: () => void;
}

const ResetConfirmDialog: React.FC<ResetConfirmDialogProps> = ({
  showResetDialog,
  setShowResetDialog,
  handleResetData
}) => {
  return (
    <Dialog open={showResetDialog} onOpenChange={setShowResetDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reset All Data</DialogTitle>
          <DialogDescription>
            This will delete all tasks, rewards, and reset your star count. This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => setShowResetDialog(false)}>
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={handleResetData}
          >
            Reset Everything
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ResetConfirmDialog;
